import { z } from 'zod';

import { uuidSchema } from './common.js';

/** Admin-only row for Pro bono settings in Adminland. */
export const clientProBonoRowSchema = z.object({
  id: uuidSchema,
  number: z.number().int().positive(),
  name: z.string().min(1).max(200),
  archived: z.boolean(),
  proBono: z.boolean(),
});
export type ClientProBonoRowDto = z.infer<typeof clientProBonoRowSchema>;

export const clientProBonoListResponseSchema = z.object({
  clients: z.array(clientProBonoRowSchema),
});
export type ClientProBonoListResponseDto = z.infer<typeof clientProBonoListResponseSchema>;

export const updateClientProBonoSchema = z.object({
  proBono: z.boolean(),
});
export type UpdateClientProBonoDto = z.infer<typeof updateClientProBonoSchema>;
